<template>
  <v-card color="grey lighten-5" flat class="store-selector">
    <v-layout row>
      <v-flex xs12 md10 offset-md1>
        <v-slide-y-transition mode="out-in">
          <!-- ^select a store -->
          <v-card v-if="showSelectAStore" class="card--loc-search">
            <v-card-title primary-title>
              <h3 class="headline mb-0">Select a store</h3>
            </v-card-title>
              <v-list three-line>
                <template v-for="(store, idx) in nearbyStores">
                    <v-list-tile :key="store.id" @click="handleStoreSelect(store)" ripple>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="nearbyStoreResultTitle(store)"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="nearbyStoreResultSubtitle(store)"></v-list-tile-sub-title>
                        <v-list-tile-sub-title v-if="signInAvailable(store)" class="orange--text" v-html="'Online Check-In Available'"></v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-list-tile-action-text><v-icon v-if="signInAvailable(store)" class="orange--text">event</v-icon></v-list-tile-action-text>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider :key="idx" v-if="showDivider(store)" />
                </template>
              </v-list>
          </v-card>
          <!-- $select a store -->
          <!-- ^get location -->
          <v-card color="primary" class="pt-5 pb-5" dark v-else>
            <div class="s2s_font display-3 text-sm-center text-xs-center">Sign to Sell</div>
            <v-card-text class="pt-5 pb-5">
              <v-btn
                color="white"
                :loading="loading"
                @click.native="queryNearbyStores"
                :disabled="loading"
                block
                large
                outline
                dark
              >
                <v-icon left>my_location</v-icon>
                Find nearby stores
              </v-btn>
            </v-card-text>
          </v-card>
          <!-- $get location -->
        </v-slide-y-transition>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="snackbar">
      Couldn't obtain location.
      <v-btn @click="queryNearbyStores" flat>Try again</v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { last } from 'lodash'
export default {
  data () {
    return {
      geolocated: false,
      longitude: null,
      latitude: null,
      loading: false,
      nearbyStores: [],
      snackbar: false
    }
  },
  computed: {
    coordinates () {
      return {
        latitude: this.latitude,
        longitude: this.longitude
      }
    },
    showSelectAStore () {
      return (this.nearbyStores.length > 0 && this.geolocated)
    }
  },
  methods: {
    ...mapActions(['getNearbyStores']),
    ...mapMutations(['setWinmarkStore', 'clearCheckinKey']),
    queryNearbyStores () {
      this.loading = true
      this.watchGeoLocation()
      if (this.coordinates && this.coordinates.latitude && this.coordinates.longitude) {
        this.getNearbyStores(this.coordinates)
          .then((response) => {
            this.nearbyStores = response.data
          })
          .catch((error) => {
            console.log(error)
          })
          .then(() => { this.loading = false })
      }
    },
    watchGeoLocation () {
      if (navigator.geolocation) {
        const success = (position) => {
          this.geolocated = true
          this.longitude = position.coords.longitude
          this.latitude = position.coords.latitude
          this.setStorageCoordinates(position.coords)
        }
        const error = (error) => {
          console.log(error)
        }
        const opts = {
          timeout: 120000,
          maximumAge: Infinity
        }
        navigator.geolocation.watchPosition(success, error, opts)
      }
    },
    getGeoLocation () {
      return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
          const success = (position) => {
            console.log(position)
            this.geolocated = true
            this.longitude = position.coords.longitude
            this.latitude = position.coords.latitude
            this.setStorageCoordinates(position.coords)
            resolve(this.geolocated)
          }
          const error = (error) => {
            reject(error)
          }
          const opts = {
            timeout: 60000, // 30 second timeout
            maximumAge: Infinity
          }
          navigator.geolocation.watchPosition(success, error, opts)
        } else {
          resolve(this.geolocated)
        }
      })
    },
    storeAddress (store) {
      return `${store.brand_name}, ${store.city}, ${store.state}`
    },
    precisionRound (number, precision) {
      const factor = Math.pow(10, precision)
      return Math.round(number * factor) / factor
    },
    nearbyStoreResultTitle (store) {
      return this.storeAddress(store)
    },
    nearbyStoreResultSubtitle (store) {
      let distance = store.distance
      let units = 'miles'
      if (store.country === 'CA') {
        distance = distance * 1.60934
        units = 'km'
      }
      return `${this.precisionRound(distance, 2)} ${units} away`
    },
    signInAvailable (store) {
      return (
        store.rai_store_number
          ? '&2713 Sign in available'
          : ''
      )
    },
    handleStoreSelect (store) {
      if (this.signInAvailable(store)) {
        this.setWinmarkStore(store)
        this.$router.push(`/s/${store.store_number}/b`)
      }
    },
    getStorageCoordinates () {
      if (window.localStorage) {
        return JSON.parse(window.localStorage.getItem('raiSTSCoordinates'))
      }
      return {
        latitude: '',
        longitude: ''
      }
    },
    setStorageCoordinates ({longitude, latitude}) {
      if (window.localStorage) {
        window.localStorage.setItem('raiSTSCoordinates', JSON.stringify({longitude, latitude}))
      }
    },
    showDivider (store) {
      return (store.id !== last(this.nearbyStores).id)
    }
  },
  created () {
    this.clearCheckinKey()
    const coords = this.getStorageCoordinates()
    if (coords) {
      this.geolocated = true
      this.longitude = coords.longitude
      this.latitude = coords.latitude
    }
  },
  watch: {
    coordinates (v) {
      this.getNearbyStores(v)
        .then((response) => {
          this.nearbyStores = response.data
        })
        .catch((error) => {
          console.log(error)
        })
        .then(() => {
          if (this.loading) this.loading = false
        })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/StoreSelector.vue